import { useState } from 'react';
import { FaPhone, FaEnvelope, FaWhatsapp } from "react-icons/fa";

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Build WhatsApp message
    const whatsappMessage = `مرحباً برولاكس،%0A%0A` +
      `الاسم: ${form.name}%0A` +
      `رقم الهاتف: ${form.phone}%0A` +
      `الرسالة: ${form.message}`;

    // Your WhatsApp number (with country code, no + or spaces)
    const phoneNumber = '972595042586';

    // Open WhatsApp
    window.open(`https://wa.me/${phoneNumber}?text=${whatsappMessage}`, '_blank');

    // Show success
    setSent(true);

    // Reset form after 3 seconds
    setTimeout(() => {
      setSent(false);
      setForm({ name: '', phone: '', message: '' });
    }, 3000);
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center px-4 pt-20" dir="rtl">
        <div className="text-center text-white">
          <div className="text-6xl mb-6">✅</div>
          <h2 className="text-3xl font-black mb-2">تم التحويل إلى واتساب!</h2>
          <p className="text-neutral-400">سيتم فتح واتساب للتواصل معنا مباشرة.</p>
          <button
            onClick={() => setSent(false)}
            className="mt-6 bg-red-600 hover:bg-red-700 text-white px-8 py-3 font-bold rounded-xl transition"
          >
            إرسال رسالة أخرى
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black py-16 px-4 pt-20" dir="rtl">
      <div className="max-w-2xl mx-auto text-white">
        <h1 className="text-4xl font-black mb-8">اتصل بنا</h1>
        <p className="text-neutral-400 mb-8">
          نحن هنا لمساعدتك. املأ النموذج أدناه وسيتم تحويلك إلى واتساب للتواصل المباشر.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-neutral-300 font-semibold mb-1">الاسم *</label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              placeholder="الاسم الكامل"
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white placeholder-neutral-500"
            />
          </div>

          <div>
            <label className="block text-neutral-300 font-semibold mb-1">رقم الهاتف *</label>
            <input
              name="phone"
              type="tel"
              value={form.phone}
              onChange={handleChange}
              required
              placeholder="مثال: 0595042586"
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white placeholder-neutral-500"
            />
          </div>

          <div>
            <label className="block text-neutral-300 font-semibold mb-1">الرسالة *</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows="5"
              required
              placeholder="اكتب رسالتك هنا..."
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white placeholder-neutral-500"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-green-600 hover:bg-green-700 text-white px-10 py-4 font-bold rounded-xl transition flex items-center justify-center gap-2 text-lg"
          >
            <FaWhatsapp className="text-xl" />
            إرسال عبر واتساب
          </button>
        </form>

        {/* Contact Info */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
          <a
            href="tel:+972595042586"
            className="bg-neutral-900 border border-neutral-800 rounded-xl p-4 text-center hover:border-red-600/50 transition group"
          >
            <FaPhone className="text-red-500 text-2xl mx-auto mb-2 group-hover:scale-110 transition" />
            <p className="text-white text-sm font-bold">اتصل بنا</p>
            <p className="text-neutral-400 text-xs">0595042586</p>
          </a>

          <a
            href="mailto:brolax.electric@gmail.com"
            className="bg-neutral-900 border border-neutral-800 rounded-xl p-4 text-center hover:border-red-600/50 transition group"
          >
            <FaEnvelope className="text-red-500 text-2xl mx-auto mb-2 group-hover:scale-110 transition" />
            <p className="text-white text-sm font-bold">البريد الإلكتروني</p>
            <p className="text-neutral-400 text-xs truncate">brolax.electric@gmail.com</p>
          </a>

          <a
            href="https://wa.me/972595042586"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-neutral-900 border border-neutral-800 rounded-xl p-4 text-center hover:border-green-600/50 transition group"
          >
            <FaWhatsapp className="text-green-500 text-2xl mx-auto mb-2 group-hover:scale-110 transition" />
            <p className="text-white text-sm font-bold">واتساب</p>
            <p className="text-neutral-400 text-xs">دردشة فورية</p>
          </a>
        </div>

        {/* Or just WhatsApp button */}
        <div className="text-center mt-10">
          <p className="text-neutral-500 text-sm mb-4">أو تواصل معنا مباشرة</p>
          <a
            href="https://wa.me/972595042586"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 font-bold rounded-xl transition text-lg shadow-lg shadow-green-600/20"
          >
            <FaWhatsapp className="text-2xl" />
            محادثة واتساب مباشرة
          </a>
        </div>
      </div>
    </div>
  );
}